/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export function transformModelPayload (model) {
    
    const payload = {
        guid: model.guid,
        type: model.type,
        version: model.version,
        title: model.title,
        description: model.description,
        banner_image: model?.banner_image || null,
        fields: [],
    };

    return payload;
}
